




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { BaseDTO } from '@/types/';

@Component({})
export default class PropertyEditor extends Vue {
  @Prop({ type: Object, required: true }) readonly model!: BaseDTO;
  @Prop({ type: String, required: true }) readonly propertyName!: string;
  @Prop({ type: Array, required: true }) readonly siblings!: string[];

  @Prop(Boolean) readonly hideEdit: boolean = false;

  editPropertyName = false;
  newPropertyName = '';
  $eventBus: any;
  localModel = new BaseDTO();

  editPropName () {
    this.editPropertyName = !this.editPropertyName;
    this.$nextTick(() => {
      const propertyInput = this.$refs.propertyName as any;
      propertyInput.focusInput();
      propertyInput.$el.getElementsByTagName('input')[0].select();
    });
  };

  updateModel () {
    this.$store.dispatch('updateModelProperty', {
      propertyName: this.newPropertyName,
      oldPropertyName: this.propertyName,
      value: this.localModel
    });
  };

  deleteProp () {
    this.$store.dispatch('deleteModelProperty', {
      id: this.model.id
    });
  };

  created () {
    this.localModel = this.model;
    this.localModel.removeKey = this.model.removeKey ? this.model.removeKey : false;
    this.newPropertyName = this.propertyName;
  };

  close () {
    this.editPropertyName = false;
  }

  mounted () {
    this.$eventBus.$on('TRIGGER_PROPERTY_EDIT', (id: string) => {
      if (id === this.model.id) {
        this.editPropName();
      }
    });
  }
}
